import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent, ConfirmDialogData, ConfirmDialogResult } from './confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {
  constructor(private matDialog: MatDialog) {}

  public open(data: ConfirmDialogData): Promise<ConfirmDialogResult> {
    return this.matDialog.open<ConfirmDialogComponent, ConfirmDialogData, ConfirmDialogResult>(ConfirmDialogComponent, {
      autoFocus: false,
      data: data
    }).afterClosed()
      .toPromise();
  }
}
